/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Rtx.Verbum.Api | v1
 * OpenAPI spec version: 1.0.0
 */

import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { useMutation, useQuery } from '@tanstack/react-query'
import { customInstance } from '../../../../core/custom-instance'
import type {
  DataEnvelopeOfObject,
  DataEnvelopeOfUnreadNotificationCountDto,
  DataPaginationEnvelopeOfNotificationDto,
  ErrorEnvelope,
  GetNotificationsParams,
  MarkNotificationsReadDto,
} from '../model'

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K }
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    })
  }
  return result
}

/**
 * @summary Lista notificações com filtros e paginação
 */
export const getNotifications = (
  params?: GetNotificationsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataPaginationEnvelopeOfNotificationDto>(
    { url: `/v1/notifications`, method: 'GET', params, signal },
    options,
  )
}

export const getGetNotificationsQueryKey = (params?: GetNotificationsParams) => {
  return [`/v1/notifications`, ...(params ? [params] : [])] as const
}

export const getGetNotificationsQueryOptions = <
  TData = Awaited<ReturnType<typeof getNotifications>>,
  TError = unknown,
>(
  params?: GetNotificationsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotifications>>, TError, TData>>
    request?: SecondParameter<typeof customInstance>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetNotificationsQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getNotifications>>> = ({ signal }) =>
    getNotifications(params, requestOptions, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getNotifications>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetNotificationsQueryResult = NonNullable<Awaited<ReturnType<typeof getNotifications>>>
export type GetNotificationsQueryError = unknown

export function useGetNotifications<
  TData = Awaited<ReturnType<typeof getNotifications>>,
  TError = unknown,
>(
  params: undefined | GetNotificationsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotifications>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotifications>>,
          TError,
          Awaited<ReturnType<typeof getNotifications>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNotifications<
  TData = Awaited<ReturnType<typeof getNotifications>>,
  TError = unknown,
>(
  params?: GetNotificationsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotifications>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotifications>>,
          TError,
          Awaited<ReturnType<typeof getNotifications>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNotifications<
  TData = Awaited<ReturnType<typeof getNotifications>>,
  TError = unknown,
>(
  params?: GetNotificationsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotifications>>, TError, TData>>
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista notificações com filtros e paginação
 */

export function useGetNotifications<
  TData = Awaited<ReturnType<typeof getNotifications>>,
  TError = unknown,
>(
  params?: GetNotificationsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotifications>>, TError, TData>>
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetNotificationsQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

/**
 * @summary Retorna a contagem de notificações não lidas
 */
export const getUnreadNotificationsCount = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfUnreadNotificationCountDto>(
    { url: `/v1/notifications/unread-count`, method: 'GET', signal },
    options,
  )
}

export const getGetUnreadNotificationsCountQueryKey = () => {
  return [`/v1/notifications/unread-count`] as const
}

export const getGetUnreadNotificationsCountQueryOptions = <
  TData = Awaited<ReturnType<typeof getUnreadNotificationsCount>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getUnreadNotificationsCount>>, TError, TData>
  >
  request?: SecondParameter<typeof customInstance>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetUnreadNotificationsCountQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUnreadNotificationsCount>>> = ({
    signal,
  }) => getUnreadNotificationsCount(requestOptions, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUnreadNotificationsCount>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUnreadNotificationsCountQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUnreadNotificationsCount>>
>
export type GetUnreadNotificationsCountQueryError = unknown

export function useGetUnreadNotificationsCount<
  TData = Awaited<ReturnType<typeof getUnreadNotificationsCount>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUnreadNotificationsCount>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUnreadNotificationsCount>>,
          TError,
          Awaited<ReturnType<typeof getUnreadNotificationsCount>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUnreadNotificationsCount<
  TData = Awaited<ReturnType<typeof getUnreadNotificationsCount>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUnreadNotificationsCount>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUnreadNotificationsCount>>,
          TError,
          Awaited<ReturnType<typeof getUnreadNotificationsCount>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUnreadNotificationsCount<
  TData = Awaited<ReturnType<typeof getUnreadNotificationsCount>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUnreadNotificationsCount>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retorna a contagem de notificações não lidas
 */

export function useGetUnreadNotificationsCount<
  TData = Awaited<ReturnType<typeof getUnreadNotificationsCount>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUnreadNotificationsCount>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetUnreadNotificationsCountQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

/**
 * @summary Marca uma lista de notificações como lidas
 */
export const markNotificationsAsRead = (
  markNotificationsReadDto: MarkNotificationsReadDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfObject>(
    {
      url: `/v1/notifications/mark-as-read`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: markNotificationsReadDto,
      signal,
    },
    options,
  )
}

export const getMarkNotificationsAsReadMutationKey = () => ['markNotificationsAsRead'] as const

export const getMarkNotificationsAsReadMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markNotificationsAsRead>>,
    TError,
    MarkNotificationsAsReadMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof markNotificationsAsRead>>,
  TError,
  MarkNotificationsAsReadMutationVariables,
  TContext
> => {
  const mutationKey = getMarkNotificationsAsReadMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof markNotificationsAsRead>>,
    MarkNotificationsAsReadMutationVariables
  > = (props) => {
    const { data } = props ?? {}

    return markNotificationsAsRead(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type MarkNotificationsAsReadMutationResult = NonNullable<
  Awaited<ReturnType<typeof markNotificationsAsRead>>
>
export type MarkNotificationsAsReadMutationBody = MarkNotificationsReadDto
export type MarkNotificationsAsReadMutationError = unknown
export type MarkNotificationsAsReadMutationVariables = { data: MarkNotificationsReadDto }

/**
 * @summary Marca uma lista de notificações como lidas
 */
export const useMarkNotificationsAsRead = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof markNotificationsAsRead>>,
      TError,
      MarkNotificationsAsReadMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof markNotificationsAsRead>>,
  TError,
  MarkNotificationsAsReadMutationVariables,
  TContext
> => {
  return useMutation(getMarkNotificationsAsReadMutationOptions(options), queryClient)
}
/**
 * @summary Marca todas as notificações do usuário como lidas
 */
export const markAllNotificationsAsRead = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfObject>(
    { url: `/v1/notifications/mark-all-as-read`, method: 'PATCH', signal },
    options,
  )
}

export const getMarkAllNotificationsAsReadMutationKey = () =>
  ['markAllNotificationsAsRead'] as const

export const getMarkAllNotificationsAsReadMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markAllNotificationsAsRead>>,
    TError,
    void,
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof markAllNotificationsAsRead>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = getMarkAllNotificationsAsReadMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof markAllNotificationsAsRead>>,
    void
  > = () => {
    return markAllNotificationsAsRead(requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type MarkAllNotificationsAsReadMutationResult = NonNullable<
  Awaited<ReturnType<typeof markAllNotificationsAsRead>>
>

export type MarkAllNotificationsAsReadMutationError = unknown

/**
 * @summary Marca todas as notificações do usuário como lidas
 */
export const useMarkAllNotificationsAsRead = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof markAllNotificationsAsRead>>,
      TError,
      void,
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof markAllNotificationsAsRead>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getMarkAllNotificationsAsReadMutationOptions(options), queryClient)
}
/**
 * @summary Exclui uma notificação do usuário
 */
export const deleteNotification = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfObject>(
    { url: `/v1/notifications/${id}`, method: 'DELETE', signal },
    options,
  )
}

export const getDeleteNotificationMutationKey = () => ['deleteNotification'] as const

export const getDeleteNotificationMutationOptions = <
  TError = ErrorEnvelope,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteNotification>>,
    TError,
    DeleteNotificationMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteNotification>>,
  TError,
  DeleteNotificationMutationVariables,
  TContext
> => {
  const mutationKey = getDeleteNotificationMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteNotification>>,
    DeleteNotificationMutationVariables
  > = (props) => {
    const { id } = props ?? {}

    return deleteNotification(id, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeleteNotificationMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteNotification>>
>

export type DeleteNotificationMutationError = ErrorEnvelope
export type DeleteNotificationMutationVariables = { id: string }

/**
 * @summary Exclui uma notificação do usuário
 */
export const useDeleteNotification = <TError = ErrorEnvelope, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteNotification>>,
      TError,
      DeleteNotificationMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteNotification>>,
  TError,
  DeleteNotificationMutationVariables,
  TContext
> => {
  return useMutation(getDeleteNotificationMutationOptions(options), queryClient)
}
/**
 * @summary Exclui todas as notificações do usuário
 */
export const deleteAllNotifications = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfObject>(
    { url: `/v1/notifications/all`, method: 'DELETE', signal },
    options,
  )
}

export const getDeleteAllNotificationsMutationKey = () => ['deleteAllNotifications'] as const

export const getDeleteAllNotificationsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAllNotifications>>,
    TError,
    void,
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAllNotifications>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = getDeleteAllNotificationsMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAllNotifications>>,
    void
  > = () => {
    return deleteAllNotifications(requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeleteAllNotificationsMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAllNotifications>>
>

export type DeleteAllNotificationsMutationError = unknown

/**
 * @summary Exclui todas as notificações do usuário
 */
export const useDeleteAllNotifications = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteAllNotifications>>,
      TError,
      void,
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteAllNotifications>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getDeleteAllNotificationsMutationOptions(options), queryClient)
}
